import { useEffect, useRef } from "react";

/**
 * Iter88zbt (2026-02-19) — Reload-Bus.
 *
 * Kleines Utility, damit unabhängige Karten auf einer Seite (z. B. die
 * „Effektive Marge"-Kachel oben und die Vertriebler-Cards unten) ihre
 * Daten automatisch neu laden, sobald IRGENDWO eine relevante Änderung
 * gespeichert wurde — ohne dass der User die Seite manuell neu laden
 * muss.
 *
 * Beispiel (Publisher):
 *   emitReload("sales-settings")            // nach patch/save
 *
 * Beispiel (Subscriber):
 *   useReloadBus("sales-settings", load)    // load = async () => fetch()
 *
 * Kanäle sind freie Strings. Sende auf „*" um alle Kanäle zu benachrichtigen.
 */

const EVENT_NAME = "novatus:reload-bus";

// Iter88zbt-fix — Micro-Task-Coalescing: wenn zwei emits im selben Tick
// gefeuert werden (z.B. `emitReload("kfw458")` + `emitReload("project-data")`),
// sammeln wir sie in einem Set und feuern EIN CustomEvent pro Tick mit dem
// gesamten Kanal-Set. Subscriber die auf `*` oder einen der Kanäle hören,
// laden dann nur einmal.
let _pending = null;
export function emitReload(channel) {
  if (typeof window === "undefined") return;
  if (!_pending) {
    _pending = new Set();
    queueMicrotask(() => {
      const channels = _pending;
      _pending = null;
      window.dispatchEvent(new CustomEvent(EVENT_NAME, {
        detail: { channels: Array.from(channels) },
      }));
    });
  }
  _pending.add(channel);
}

export function useReloadBus(channel, handler) {
  // Handler in Ref halten, damit Listener stabil bleibt und nicht bei
  // jedem Render neu registriert wird (verhindert Race-Windows).
  const handlerRef = useRef(handler);
  useEffect(() => { handlerRef.current = handler; }, [handler]);

  useEffect(() => {
    if (typeof window === "undefined") return undefined;
    const onEvt = (e) => {
      const channels = e?.detail?.channels || (e?.detail?.channel ? [e.detail.channel] : []);
      const match = channels.some((c) => c === "*" || c === channel);
      if (!match) return;
      try { handlerRef.current?.(); }
      catch (err) {
        // Fehler explizit sichtbar machen — sonst bleibt eine Karte
        // stumm-stale ohne jeden Hinweis.
        console.warn(`[reloadBus] handler for channel "${channel}" failed:`, err);
      }
    };
    window.addEventListener(EVENT_NAME, onEvt);
    return () => window.removeEventListener(EVENT_NAME, onEvt);
  }, [channel]);
}
